import { render, staticRenderFns } from "./permission-component.vue?vue&type=template&id=3eb1dbaa&scoped=true"
import script from "./permission-component.vue?vue&type=script&lang=js"
export * from "./permission-component.vue?vue&type=script&lang=js"
import style0 from "./permission-component.vue?vue&type=style&index=0&id=3eb1dbaa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb1dbaa",
  null
  
)

export default component.exports